import React from "react";
import { Reveal, StaggerGroup, StaggerItem } from "./Reveal";

const SKILLS = [
  "Branding",
  "Brand Strategy",
  "Visual Identity",
  "Social Media Design",
  "Presentation Design",
  "Landing Pages",
  "Creative Direction",
  "AI-powered Workflows",
];

export const About = () => {
  return (
    <section id="about" className="py-24 md:py-32 lg:py-40" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        {/* Sticky left */}
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <Reveal>
              <div className="flex items-center gap-3 mb-6">
                <span className="h-px w-10 bg-gold" />
                <span className="text-xs tracking-[0.25em] uppercase font-semibold text-gold">
                  About
                </span>
              </div>
              <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-charcoal">
                Strategy first.
                <br />
                <span className="italic text-burgundy">Beauty always.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="mt-10 flex items-end gap-4">
                <span className="font-heading text-7xl md:text-8xl text-charcoal leading-none">11</span>
                <div className="pb-3">
                  <p className="font-heading text-3xl text-gold leading-none">+</p>
                  <p className="text-sm text-charcoal/60 mt-1">years of<br />experience</p>
                </div>
              </div>
            </Reveal>
          </div>
        </div>

        {/* Scrollable right */}
        <div className="lg:col-span-7 lg:pt-4">
          <Reveal>
            <p className="font-heading text-2xl md:text-3xl leading-snug text-charcoal">
              Strategy comes first. Every creative decision follows with purpose.
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 text-base md:text-lg leading-relaxed text-charcoal/70">
              Over the past eleven years I've partnered with founders, startups and global teams
              across the USA, UK, UAE and Australia — translating ambitious business goals into
              brand systems that actually perform. My approach begins with strategy: understanding
              the market, the audience, and the problem worth solving.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-6 text-base md:text-lg leading-relaxed text-charcoal/70">
              From there, creative direction and craft take over — visual identities, packaging,
              landing pages, presentations and campaigns designed to build trust and drive results.
              Today I blend that craft with{" "}
              <span className="text-charcoal font-medium">AI-powered creative workflows</span> to
              move faster, explore more, and deliver premium work at pace.
            </p>
          </Reveal>

          <Reveal delay={0.2}>
            <p className="mt-12 text-xs tracking-[0.2em] uppercase text-charcoal/40 mb-6">
              What I do best
            </p>
          </Reveal>
          <StaggerGroup className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-0" stagger={0.06}>
            {SKILLS.map((s) => (
              <StaggerItem key={s}>
                <div className="group flex items-center justify-between py-4 border-b border-charcoal/10 cursor-hover">
                  <span className="text-lg text-charcoal group-hover:text-burgundy group-hover:translate-x-1 transition-all duration-300">
                    {s}
                  </span>
                  <span className="text-gold opacity-0 group-hover:opacity-100 transition-opacity">✦</span>
                </div>
              </StaggerItem>
            ))}
          </StaggerGroup>
        </div>
      </div>
    </section>
  );
};
